var _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKoalyLogoFull(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 275,
    viewBox: "0 0 1000 275",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 599.276h845.89V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 799.035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.421-4.419-9.521-6.8-16.916-6.8-7.394 0-12.494 2.381-16.915 6.8-6.374 6.376-6.119 14.875-6.119 23.97 0 9.095-.255 17.595 6.119 23.971 4.421 4.419 9.521 6.799 16.915 6.799 7.395 0 12.495-2.38 16.916-6.799 6.376-6.376 6.12-14.876 6.12-23.971S6.376 6.376 0 0m-10.965 38.845c-1.105 1.446-3.23 2.634-5.951 2.634-2.72 0-4.844-1.188-5.949-2.634-1.36-1.785-2.209-3.825-2.209-14.875 0-11.051.849-13.005 2.209-14.79 1.105-1.446 3.229-2.72 5.949-2.72 2.721 0 4.846 1.274 5.951 2.72 1.36 1.785 2.21 3.739 2.21 14.79 0 11.05-.85 13.09-2.21 14.875",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 449.018 477.936)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.806 9.01h-18.615L-24.394 0H-39.95l22.015 60.521H-6.46L15.555 0Zm-11.814 37.57-5.441-16.149h10.54z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 541.287 465.544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v60.521h14.875V13.26h25.416V0Z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 578.965 465.544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-24.65h-14.875V0l-18.276 35.87h16.235l9.521-21.76 9.433 21.76h16.236z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 710.249 514.105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-6.786 20.707 4.07 42.849 24.252 49.464a37.577 37.577 0 0 0 11.704 1.874 42.364 42.364 0 0 1-8.67 1.838C4.767 55.527-15.343 39.685-17.629 17.783c-2.293-21.911 14.101-41.579 36.616-43.93a42.403 42.403 0 0 1 8.643-.021C15.13-22.925 4.398-13.41 0 0",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 38.9 459.643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-11.436 18.824-36.387 24.557-55.736 12.804a42.37 42.37 0 0 1-7.047-5.367 37.335 37.335 0 0 0 11.378 3.31C-30.34 13.392-11.063-1.988-8.344-23.61c1.756-14-3.874-27.19-13.795-35.464a42.723 42.723 0 0 1 7.803 3.708C5.013-43.615 11.432-18.828 0 0",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 236.69 546.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.581 20.408-24.839 33.239-45.245 28.658-20.41-4.574-33.239-24.834-28.658-45.24 4.581-20.412 24.839-33.236 45.25-28.658C-8.248-40.659 4.576-20.399 0 0m-62.609-11.787a3.5 3.5 0 0 0 0 7.001 3.506 3.506 0 0 0 3.498-3.504 3.507 3.507 0 0 0-3.498-3.497m33.567-31.722c-10.38-2.329-21.698 8.747-25.295 24.738-3.588 15.988 1.911 30.841 12.292 33.174 10.38 2.327 21.699-8.749 25.288-24.74 3.585-15.992-1.913-30.84-12.285-33.172M-14.86.798a3.504 3.504 0 0 0-3.504 3.503 3.5 3.5 0 0 0 7.001 0A3.5 3.5 0 0 0-14.86.798",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 201.812 498.829)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.67 0 4.144-1.044 4.758-1.749l-1.596-1.75c-.676.706-1.658 1.381-3.285 1.381-2.701 0-4.512-1.78-4.512-6.446 0-4.757 1.719-6.568 4.512-6.568 1.535 0 2.579.553 3.254 1.32l1.473-1.657c-.675-.768-2.087-1.781-4.942-1.781-4.082 0-6.752 2.363-6.752 8.38C-7.09-2.732-4.082 0 0 0",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 282.137 441.78)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.223 0 4.389 2.118 4.389 6.477 0 4.481-1.35 6.66-4.573 6.66-3.162 0-4.359-2.117-4.359-6.446C-4.543 2.21-3.192 0 0 0m-6.998 6.507c0 5.157 1.933 8.686 6.998 8.686 5.095 0 6.845-3.437 6.845-8.532 0-5.157-1.965-8.748-7.029-8.748-5.065 0-6.814 3.469-6.814 8.594",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 310.376 411.91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.021.153-7.182-.829-7.182-3.346 0-1.473 1.074-2.67 3.008-2.67 1.903 0 3.407 1.135 4.174 2.271zm2.21 4.235v-7.551c0-1.503.46-2.516 1.627-2.516h.43v-1.749c-.215-.124-.553-.185-.86-.185-1.658 0-2.64.891-3.038 2.026H.246c-.798-.921-2.149-2.241-4.973-2.241-3.1 0-4.819 2.18-4.819 4.451C-9.546.153-5.924 1.964 0 1.872v1.811c0 2.731-1.32 3.529-3.53 3.529-2.24 0-3.315-1.227-3.806-2.025l-1.749 1.381c.583.798 2.148 2.732 5.617 2.732 3.56 0 5.678-1.566 5.678-5.065",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 349.136 423.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-19.337c0-1.473.491-2.118 1.749-2.118.614 0 1.075.184 1.382.337v-2.025c-.614-.276-1.443-.368-2.088-.368-2.301 0-3.406 1.35-3.406 3.529V0Z",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 370.12 454.237)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.311 403.485h4.082v-28.466h-4.082zm1.78 11.303c1.727 0 3.035-1.257 3.035-2.982 0-1.676-1.308-2.932-3.035-2.932-1.623 0-2.93 1.256-2.93 2.932 0 1.725 1.307 2.982 2.93 2.982",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.70482
    },
    transform: "translate(-56.537 -25.01) scale(1.15555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v10.313h-2.486v1.535l2.486.46.736 4.328h1.627v-4.389h4.604v-1.934H2.363V.122c0-1.872.952-2.639 2.426-2.639 1.35 0 2.117.307 2.547.583l.675-1.903c-.645-.368-1.75-.767-3.744-.767C1.504-4.604 0-3.162 0 0",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 401.018 417.11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.37 403.485h4.082v-28.466h-4.081zm1.78 11.303c1.728 0 3.035-1.257 3.035-2.982 0-1.676-1.307-2.932-3.034-2.932-1.622 0-2.93 1.256-2.93 2.932 0 1.725 1.308 2.982 2.93 2.982",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.70482
    },
    transform: "translate(-56.537 -25.01) scale(1.15555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.223 0 4.389 2.118 4.389 6.477 0 4.481-1.35 6.66-4.573 6.66-3.162 0-4.359-2.117-4.359-6.446C-4.543 2.21-3.192 0 0 0m-6.998 6.507c0 5.157 1.933 8.686 6.998 8.686 5.095 0 6.845-3.437 6.845-8.532 0-5.157-1.964-8.748-7.029-8.748-5.065 0-6.814 3.469-6.814 8.594",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 452.536 411.91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-2.394v10.958c0 2.547-1.259 3.959-3.591 3.959-2.057 0-3.653-1.35-4.236-2.977V0h-2.394v16.697h1.811l.49-1.75h.124c.46.584 2.148 2.088 4.757 2.088 3.345 0 5.341-1.811 5.433-5.525z",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 499.158 408.343)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.775 0 5.647 2.21 5.647 6.661 0 4.696-2.117 6.2-4.327 6.2-2.056 0-3.253-1.259-3.837-2.333V.368C-1.811.123-.675 0 0 0m.123-2.117c-.859 0-1.811.092-2.64.276v-6.201H-4.88v22.653h1.78l.522-1.689h.123c.798 1.075 2.209 1.995 4.327 1.995 3.807 0 6.201-2.547 6.201-7.98 0-5.832-3.162-9.054-7.95-9.054",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 536.769 412.453)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.614.184-1.258.245-1.872.245-1.627 0-3.315-.644-4.113-2.149v-12.43h-2.363V2.363h1.81l.522-1.842h.123c.736 1.198 2.271 2.118 4.205 2.118.767 0 1.32-.061 1.688-.154z",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 577.404 436.581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.223 0 4.389 2.118 4.389 6.477 0 4.481-1.35 6.66-4.573 6.66-3.162 0-4.359-2.117-4.359-6.446C-4.543 2.21-3.192 0 0 0m-6.998 6.507c0 5.157 1.933 8.686 6.998 8.686 5.095 0 6.845-3.437 6.845-8.532 0-5.157-1.964-8.748-7.029-8.748-5.065 0-6.814 3.469-6.814 8.594",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 594.819 411.91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.223 0-5.371-2.117-5.371-6.538 0-4.787 2.209-6.046 4.573-6.046 1.32 0 2.732.583 3.529 1.627V-.46C2.026-.184 1.074 0 0 0m5.095-14.886c0-4.39-2.701-6.569-6.875-6.569-3.161 0-4.819 1.105-5.495 1.781l1.382 1.902c.828-.828 2.148-1.565 4.389-1.565 3.039 0 4.266 1.473 4.266 4.451v1.535h-.123c-.521-.461-1.933-1.32-4.082-1.32-3.438 0-6.353 2.148-6.353 7.827 0 5.341 2.609 8.932 8.134 8.932 2.117 0 3.744-.369 4.757-.86z",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 630.195 437.426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.614.184-1.258.245-1.872.245-1.627 0-3.315-.644-4.113-2.149v-12.43h-2.363V2.363h1.81l.522-1.842h.123c.736 1.198 2.271 2.118 4.205 2.118.767 0 1.32-.061 1.688-.154z",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 666.716 436.581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-4.021.153-7.182-.829-7.182-3.346 0-1.473 1.074-2.67 3.007-2.67 1.904 0 3.408 1.135 4.175 2.271zm2.21 4.235v-7.551c0-1.503.46-2.516 1.627-2.516h.43v-1.749c-.215-.124-.553-.185-.86-.185-1.657 0-2.639.891-3.039 2.026H.246c-.798-.921-2.149-2.241-4.973-2.241-3.1 0-4.819 2.18-4.819 4.451C-9.546.153-5.924 1.964 0 1.872v1.811c0 2.731-1.32 3.529-3.529 3.529-2.241 0-3.316-1.227-3.807-2.025l-1.75 1.381c.584.798 2.149 2.732 5.617 2.732C.092 9.3 2.21 7.734 2.21 4.235",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 687.88 423.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.315 0 5.157-1.872 5.157-5.525v-11.51H2.793v11.018c0 2.579-1.227 3.899-3.284 3.899-2.087 0-3.407-1.443-3.836-2.793v-12.124h-2.395v10.834c0 2.64-1.166 4.083-3.314 4.083-2.088 0-3.439-1.535-3.776-2.977v-11.94h-2.394V-.338h1.841l.492-1.78h.122C-13.29-1.412-12.032 0-9.422 0c2.485 0 3.805-1.136 4.419-2.64h.122C-4.235-1.29-2.609 0 0 0",
    style: {
      fill: "#909194",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 735.772 441.902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13.94 24.819-5.1-5.863V0h-14.705v60.521h14.705V39.1l17.51 21.421h18.19l-20.655-24.48L17.34 0Z",
    style: {
      fill: "currentColor",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.97 0 0 1.97 334.648 465.544)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoalyLogoFull);
export default __webpack_public_path__ + "static/media/koaly_logo_full.e92c8cd4.svg";
export { ForwardRef as ReactComponent };